import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-black text-white border-t border-zinc-900">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-red-500">Yhteystiedot</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="text-red-500 mt-1 flex-shrink-0" size={20} />
                <div>
                  <p className="text-white/90">Keskuskatu 5</p>
                  <p className="text-white/90">35700 Vilppula</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-red-500 flex-shrink-0" size={20} />
                <a href="tel:0449890893" className="text-white/90 hover:text-red-500 transition-colors">
                  044 9890 893
                </a>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-red-500">Avoinna</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <Clock className="text-red-500 flex-shrink-0" size={20} />
                <div>
                  <p className="text-white/90">Ma-Pe: 10.30-21.00</p>
                  <p className="text-white/90">La-Su: 11.00-21.00</p>
                </div>
              </div>
            </div>
          </div>

          {/* Logo */}
          <div className="flex flex-col items-start md:items-end">
            <img
              src="https://customer-assets.emergentagent.com/job_9488e97a-b5e4-42e0-a94e-fc381306b65d/artifacts/607k4yn7_Logo%402x.png"
              alt="Ravintola Vilppula"
              className="h-20 w-auto mb-4"
            />
            <p className="text-white/60 text-sm">
              Aitoja makuja Vilppulassa
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-900 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Ravintola Vilppula. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
